import { observer } from "mobx-react-lite";
import { useField } from "react-final-form";

import {
  FontIcon,
  Heading,
  metaToLabelColor,
  Stack,
  TooltipHost,
  useTheme
} from "@bps/fluent-ui";

import { LocationDetailsValues } from "./LocationDetails.types.ts";

interface LocationDetailsFormFieldLabelProps {
  disabled?: boolean;
  label: string;
  tooltip?: string;
  nameOfField: keyof LocationDetailsValues;
}

export const LocationDetailsFormFieldLabel = observer(
  ({
    label,
    tooltip,
    nameOfField,
    disabled
  }: LocationDetailsFormFieldLabelProps) => {
    const fieldValue = useField(nameOfField, {
      subscription: {
        active: true,
        modified: true,
        submitFailed: true,
        touched: true,
        error: true
      }
    });

    const theme = useTheme();
    return (
      <Stack horizontal tokens={{ childrenGap: 4 }} horizontalAlign="start">
        <Heading
          hasAsterisk
          styles={{
            root: {
              color: disabled
                ? theme.semanticColors.disabledText
                : metaToLabelColor(
                    {
                      active: fieldValue.meta.active,
                      hasErrorMessage:
                        (fieldValue.meta.modified && fieldValue.meta.touched) ||
                        fieldValue.meta.submitFailed
                          ? fieldValue.meta.error
                          : undefined
                    },
                    theme
                  )
            }
          }}
        >
          {label}
          {tooltip && (
            <TooltipHost
              content={tooltip}
              styles={{ root: { display: "inline", marginLeft: 4 } }}
            >
              <FontIcon
                iconName="Info"
                styles={{ root: { position: "relative", top: 2 } }}
              />
            </TooltipHost>
          )}
        </Heading>
      </Stack>
    );
  }
);
